import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { DatastoreService } from './index';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  config: any
  selectedSlot: any
  availableTimesService: any
  availableDaysService: any

  constructor(
    private http: HttpClient,
    private dataStore: DatastoreService) {
  }

  async login(loginForm: any) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      const body = {
        "email": loginForm.email,
        "password": loginForm.password
      }

      return await this.http.post(`${environment.apiServer}/admin/login`, body, { headers }).toPromise();
    } catch (error) {
      console.log(error)
      return null;
    }
  }

  async customSsoLogin(companyId: any, email: string, key: string, value: any) {
    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      const bodyData = {
        email: `${email}`,
        key: `${key}`,
        value: `${value}`
      };

      return await this.http.post(`${environment.apiServer}/company/${companyId}/sso/login/custom`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async passwordReset(email: string, companyId: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyId}`
      };

      const bodyData = {
        "email": email
      }
      return await this.http.post(`${environment.apiServer}/company/${companyId}/forgot-password`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getCompany(companyid: any) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${companyid}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getClient(companyid: any, id: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      return await this.http.get(`${environment.apiServer}/company/${companyid}/client/${id}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getCompanies() {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/companies`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getChildCompanies(company_id: number) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/children`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getResource(company_id: number, resource_id: number) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/resource/${resource_id}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getResources(company_id: number) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/resources`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }
  async getServiceResources(company_id: number, service_id: number) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/service/${service_id}/resources`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getServices(company_id: number) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/services`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getService(company_id: number, service_id: number) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/service/${service_id}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getMember(company_id: number, member_id: number) {
    try {
      const authToken = this.dataStore.authToken;
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${company_id}`
      };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/member/${member_id}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async findClientByEmail(companyid: any, emailURI: string) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${companyid}/client/email/${emailURI}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getServiceCompanies() {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/service/companies`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getMemberBookings(company_id: number, memberid: number) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${company_id}`
      };
      const r = await this.http.get(`${environment.apiServer}/company/${company_id}/member/${memberid}/bookings`, { headers }).toPromise();
      return r
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async getBookings(company_id: number, params: string) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${company_id}`
      };
      const r = await this.http.get(`${environment.apiServer}/company/${company_id}/bookings${params}`, { headers }).toPromise();
      return r
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async getBookingsCacheForDay(company_id: number, date: string, hours: any) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${company_id}`
      };
      const r = await this.http.get(`${environment.apiServer}/daysbookings?company=${company_id}&date=${date}&hours=${hours}`, { headers }).toPromise();
      return r
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async getPastBookings(company_id: number, memberid: number) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${company_id}`
      };
      const r = await this.http.get(`${environment.apiServer}/company/${company_id}/member/${memberid}/past-bookings`, { headers }).toPromise();
      return r
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async getBookingsAttendees(company_id: number, memberid: number, id: number) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
      };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/member/${memberid}/bookings/${id}/attendees`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getBooking(company_id: number, bookingid: string) {

    // const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'authtoken': authToken,
        'x-company-id': `${company_id}`
      };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/booking/${bookingid}`, { headers }).toPromise();
    } catch (error) {
      console.log(error);
      return (error as Error).message;
    }
  }

  async getMemberBooking(company_id: number, memberid: number, bookingId: number) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${company_id}`
      };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/member/${memberid}/bookings/${bookingId}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async patchMember(company_id: number, member_id: number, body: any) {

    const authToken = this.dataStore.authToken;
    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${member_id}`,
        'authtoken': authToken,
        'x-company-id': `${company_id}`
      };

      return await this.http.patch(`${environment.apiServer}/company/${company_id}/member/${member_id}`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async getServiceDates(company_id: number, service_id: number, start_date: String, end_date: String, resource: any, duration: any) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      let url = `${environment.apiServer}/company/${company_id}/service/${service_id}/days/${start_date}/${end_date}`;
      let join = '?';
      if (resource) {
        url = `${url}${join}resources=${resource}`;
        join = '&';
      }
      if (duration) {
        url = `${url}${join}duration=${duration}`;
      }
      return await this.http.get(`${url}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getBookedDates(company_id: number, service_id: number, resource_id: number, date: String) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      let url = `${environment.apiServer}/company/${company_id}/service/${service_id}/resource/${resource_id}/unavailable/${date}`;
      return await this.http.get(`${url}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async putCheckinBooking(company_id: number, memberid: number, bookingid: number) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${company_id}`
      };

      return await this.http.put(`${environment.apiServer}/bookings/${bookingid}/checkin/${memberid}`, {}, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getServiceTimes(company_id: number, service_id: number, start_date: String, end_date: String, resource: any, duration: any = null, bookingId: any = null, resources: any = null) {
    try {
      // get config to check for cache
      let url = `${environment.apiServer}/company/${company_id}/service/${service_id}/times/${start_date}/${end_date}`;

      const headers = { 'Content-Type': 'application/json' };

      let join = '?';
      if (resource) { // does a differnat search. needed so we use the v5 api which gives us nicer formating and works with ignoreBooking
        resources = null;
        url = `${environment.apiServer}/company/${company_id}/service/${service_id}/resource/${resource}/times/${start_date}/${end_date}`;
      }
      if (bookingId !== null) {
        url = `${url}${join}ignore_booking=${bookingId}`;
        join = '&'
      }
      if (duration) {
        url = `${url}${join}duration=${duration}`;
      }
      if (resources) {
        resource = null;
        url = `${url}${join}resources=${resources}`;
      }
      const config: any = sessionStorage.getItem('config');
      const configObj = JSON.parse(config);
      if (configObj.hasOwnProperty('cache')) {
        if (configObj.cache.hasOwnProperty('cache_find_button')) {
          if (configObj.cache.cache_find_button) {
            url = `${url}&cache_find=true`;
          }
        }
      }
      return await this.http.get(url, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getCheckoutBooking(company_id: number, memberid: number, bookingid: number) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${company_id}`
      };
      return await this.http.put(`${environment.apiServer}/bookings/${bookingid}/checkout/${memberid}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  // async getServiceDates(company_id: number, service_id: number, start_date: Date, duration: number) {
  //   let startDate = start_date.toISOString().split("T")[0];
  //   let endDateUnix = await this.utils.addDays(start_date, duration);
  //   let endDate = new Date(endDateUnix).toISOString().split("T")[0];
  //   try {
  //     const headers = { 'Content-Type': 'application/json' };
  //     return await this.http.get(`${environment.apiServer}/company/${company_id}/service/${service_id}/days/${startDate}/${endDate}`, { headers }).toPromise();
  //   } catch (error) {
  //     return (error as Error).message;
  //   }
  // }

  // async getServiceTimes(company_id: number, service_id: number, date: Date) {
  //   try {
  //     const headers = { 'Content-Type': 'application/json' };
  //     return await this.http.get(`${environment.apiServer}/company/${company_id}/services`, { headers }).toPromise();
  //   } catch (error) {
  //     return (error as Error).message;
  //   }
  // }

  async getCancelBooking(company_id: number, memberid: number, bookingid: number) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${company_id}`
      };
      return await this.http.delete(`${environment.apiServer}/company/${company_id}/member/${memberid}/bookings/${bookingid}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async removeAttendee(company_id: number, memberid: number, bookingid: number, attendee_id: number) {

    const authToken = this.dataStore.authToken;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${company_id}`
      };

      return await this.http.delete(`${environment.apiServer}/company/${company_id}/member/${memberid}/bookings/${bookingid}/attendees/${attendee_id}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async createBasket() {

    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.childCompany;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "company_id": companyid
      }

      return await this.http.post(`${environment.apiServer}/basket`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getBaskets() {
    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.childCompany;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };

      return await this.http.get(`${environment.apiServer}/baskets`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async deleteBaskets() {
    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.client.id;
    const companyid = JSON.parse(this.dataStore.config).company;


    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };

      return await this.http.delete(`${environment.apiServer}/baskets`, { headers }).toPromise();
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async addServiceItem(basket_id: any) {

    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.childCompany;
    const serviceid = this.dataStore.bookingDetails.serviceId;
    const resourceid = this.dataStore.bookingDetails.resourceId;
    const start = this.dataStore.bookingDetails.time;
    const duration = this.dataStore.bookingDetails.duration;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "company_id": companyid,
        "service_id": serviceid,
        "resource_id": resourceid,
        "start": start,
        "duration": parseInt(duration),
        "questions": []
      }

      return await this.http.post(`${environment.apiServer}/baskets/${basket_id}/service_item`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async updateServiceItem(questionsObj: any) {

    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.childCompany;
    const serviceid = this.dataStore.bookingDetails.serviceId;
    const resourceid = this.dataStore.bookingDetails.resourceId;
    const basketid = this.dataStore.basket.id;
    const serviceitemid = this.dataStore.serviceItem.id;
    const start = this.dataStore.serviceItem.start;
    const duration = this.dataStore.bookingDetails.duration;
    const questions = questionsObj;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "company_id": companyid,
        "service_id": serviceid,
        "resource_id": resourceid,
        "start": start,
        "duration": parseInt(duration),
        "questions": questions
      }

      return await this.http.put(`${environment.apiServer}/baskets/${basketid}/service_item/${serviceitemid}`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async checkout() {

    const authToken = this.dataStore.authToken;
    const companyid = this.dataStore.company.id;
    const basketid = this.dataStore.basket.id;
    const serviceid = this.dataStore.bookingDetails.serviceId;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${this.dataStore.client.id}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "service_id": serviceid,
        "customer_id": this.dataStore.client.id,
        "date": this.dataStore.selectedDate,
        "no_notifications": true
      };

      return await this.http.post(`${environment.apiServer}/baskets/${basketid}/public-checkout`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async dayCheckout() {
    const companyid = JSON.parse(this.dataStore.config).company;
    const serviceid = this.dataStore.bookingDetails.serviceId;
    const authToken = this.dataStore.authToken;
    const start = this.dataStore.bookingDetails.time;
    const duration = this.dataStore.bookingDetails.duration;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${this.dataStore.client.id}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "service_id": serviceid,
        "customer_id": this.dataStore.client.id,
        "date": this.dataStore.selectedDate,
        "no_notifications": true
      };

      //https://m5nius1kad.execute-api.eu-west-2.amazonaws.com/1/company/52481/service/112376/day-based/checkout-public
      return await this.http.post(`${environment.apiServer}/company/${companyid}/service/${serviceid}/day-based/checkout-public`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async moveBooking(booking: any, date: any, time: any, duration: any) {

    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.childCompany;
    const bookingid = booking.id;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "date": date,
        "time": time,
        "duration": duration
      };

      return await this.http.put(`${environment.apiServer}/company/${companyid}/member/${memberid}/bookings/${bookingid}/move`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async questions(service: any) {
    // const authToken = this.dataStore.authToken;
    // const memberid = this.dataStore.member.id;
    const companyid = JSON.parse(this.dataStore.config).company;
    const detailgroupid = service.detail_group_id;

    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      return await this.http.get(`${environment.apiServer}/company/${companyid}/questions/${detailgroupid}?showAdmin=true&showOutcome=true`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async attendees() {

    const companyid = this.dataStore.childCompany;
    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const serviceid = this.dataStore.serviceItem.id;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const basketid = this.dataStore.basket.id;

      return await this.http.get(`${environment.apiServer}/baskets/${basketid}/service_items/${serviceid}/attendees`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async addAttendee(attendee: any, company_id: number = -1, booking: number = -1) {

    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.childCompany;

    try {

      const body = {
        "email": attendee.email,
        "telephone": attendee.mobile,
        // "type": "customer",
        // "primary_attendee": false,
        "name": attendee.name,
        "first_name": attendee.first_name,
        "last_name": attendee.last_name
      };
      if (company_id === -1) {
        const headers = {
          'Content-Type': 'application/json',
          'x-member-id': `${memberid}`,
          'authtoken': authToken,
          'x-company-id': `${companyid}`
        };
        const basketid = this.dataStore.basket.id;
        const serviceid = this.dataStore.serviceItem.id;
        return await this.http.post(`${environment.apiServer}/baskets/${basketid}/service_items/${serviceid}/attendees`, body, { headers }).toPromise();
      } else {
        const headers = {
          'Content-Type': 'application/json',
          'x-member-id': `${memberid}`,
          'authtoken': authToken,
          'x-company-id': `${company_id}`
        };
        return await this.http.post(`${environment.apiServer}/company/${company_id}/member/${memberid}/bookings/${booking}/attendees`, body, { headers }).toPromise();
      }
    } catch (error) {
      return (error as Error).message;
    }
  }

  async updateBooking(body: any, company_id: number, booking: number) {

    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.company.id;
    // const basketid = this.dataStore.basket.id;
    // const serviceid = this.dataStore.serviceItem.id;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };

      return await this.http.put(`${environment.apiServer}/company/${company_id}/booking/${booking}`, body, { headers }).toPromise();

    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async searchAttendee(searchString: String) {

    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.company;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "term": searchString
      }

      return await this.http.post(`${environment.apiServer}/company/${companyid}/client/search`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getResourceMap() {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/config/resource-map`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getResourceAvailability(date: String, resourceList: any, duration: any) {
    const companyid = this.dataStore.bookingDetails.childCompanyId;
    const serviceid = this.dataStore.bookingDetails.serviceId;
    console.log(`service id is ${serviceid}`);
    let url = `${environment.apiServer}/company/${companyid}/service/${serviceid}/times/${date}/${date}?resources=${resourceList}&duration=${duration}`;
    try {
      // get config to check for cache
      const config: any = sessionStorage.getItem('config');
      const configObj = JSON.parse(config);
      if (configObj.hasOwnProperty('cache')) {
        if (configObj.cache.hasOwnProperty('cache_find_button')) {
          if (configObj.cache.cache_find_button) {
            url = `${url}&cache_find=true`;
          }
        }
      }
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(url, { headers }).toPromise();
      // return await this.http.get(`${environment.apiServer}/company/${companyid}/service/${serviceid}/resource/${resourceid}/times/${date}/${date}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getMeetingRoomBookings(companyid: any, serviceid: any, resourceid: any, date: any) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${companyid}/service/${serviceid}/resource/${resourceid}/bookings/${date}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async bookingCheckin(bookingid: Number, memberid: Number) {

    const companyid = this.dataStore.company;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyid}`
      };
      const body = {
      }

      return await this.http.put(`${environment.apiServer}/bookings/${bookingid}/checkin/${memberid}`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async bookingCheckout(bookingid: Number, memberid: Number) {

    const companyid = this.dataStore.company;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyid}`
      };
      const body = {
      }

      return await this.http.put(`${environment.apiServer}/bookings/${bookingid}/checkout/${memberid}`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async bookingNoshow(bookingid: Number, memberid: Number) {

    const companyid = this.dataStore.company;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyid}`
      };
      const body = {
      }

      return await this.http.put(`${environment.apiServer}/bookings/${bookingid}/noshow/${memberid}`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async bookingCancel(companyid: Number, bookingid: Number, notify: boolean, reason: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyid}`
      };
      const body = {
        "notify": notify,
        "reason": reason
      }

      return await this.http.post(`${environment.apiServer}/company/${companyid}/booking/${bookingid}/cancel`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async addNotesToBooking(companyid: Number, bookingid: Number, note: String) {

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyid}`,
        'no-loader': `true`
      };
      const body = {
        "note": note
      }

      return await this.http.post(`${environment.apiServer}/company/${companyid}/booking/${bookingid}/note`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async addNotes(companyId: Number, bookingId: Number, note: String) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyId}`
      };
      const data: any = {
        "private_note": note
      }
      return await this.http.put(`${environment.apiServer}/company/${companyId}/booking/${bookingId}`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async saveSettings(companyId: Number, bookingId: Number, settings: String) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyId}`
      };
      const data: any = {
        "settings": settings
      }
      return await this.http.put(`${environment.apiServer}/company/${companyId}/booking/${bookingId}`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async updateAnswers(companyId: Number, bookingId: Number, questions: any) {
    const sendingQuestions = JSON.parse(JSON.stringify(questions))
    console.log(sendingQuestions)
    for (let i of Object.keys(sendingQuestions)) { // 
      if (sendingQuestions[i].answer === "Yes") {
        sendingQuestions[i].answer = true
      } else if (sendingQuestions[i].answer === "No") {
        sendingQuestions[i].answer = false
      }
    }
    try {
      console.log("ya")
      // const authToken = this.dataStore.authToken;
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyId}`,
        // 'authtoken': authToken,
      };
      console.log("y2")

      const data: any = {
        "questions": questions
      }
      console.log("here", `${environment.apiServer}/company/${companyId}/booking/${bookingId}`, data, { headers })
      return await this.http.put(`${environment.apiServer}/company/${companyId}/booking/${bookingId}`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async addToMessageQueue(action: String, booking: any, attendee: String) {

    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.childCompany;
    const parentid = this.dataStore.bookingDetails.parentCompanyId;
    const parent = this.dataStore.childCompanies.find((c: any) => c.id == parentid);
    const company = this.dataStore.companies.find((c: any) => c.id == companyid);
    const serviceid = this.dataStore.bookingDetails.serviceId;
    const client = this.dataStore.client;

    // if we are booking a desk, set the message_type to deskInvite.
    let message_type = 'email';
    if (this.dataStore.selectedService.hasOwnProperty('extra')) {
      if (this.dataStore.selectedService.extra.hasOwnProperty('service_type')) {
        if (this.dataStore.selectedService.extra.service_type === 'Book a desk') {
          // load the question from config
          const config = sessionStorage.getItem('config') as any;
          const configObj = JSON.parse(config);
          if (configObj.hasOwnProperty('deskBehalfOptions')) {
            const configQuestion = configObj.deskBehalfOptions.question;
            if (this.dataStore.member.q.hasOwnProperty(configQuestion)) {
              if (this.dataStore.member.q[configQuestion].answer === 'Yes') {
                message_type = 'deskInvite';
              }
            }
          }
        }
      }
    }

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "client": client,
        "company": company,
        "parent": parent,
        "service": serviceid,
        "action": action,
        "booking": booking,
        "attendee": attendee,
        "message_type": message_type
      }

      const url = `${environment.apiServer}/company/${companyid}/messages`;

      return await this.http.post(url, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async addExistingMessageToQueue(action: String, booking: any, attendee: String) {

    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.childCompany;
    const company: any = await this.getCompany(booking.company_id);
    const parentid = company.parent;
    const parent = await this.getCompany(parentid);
    const serviceid = booking.service_id;
    const client = this.dataStore.client;

    const service = await this.getService(company.id, serviceid) as any;

    let message_type = 'email';
    if (service.hasOwnProperty('extra')) {
      if (service.extra.hasOwnProperty('service_type')) {
        if (service.extra.service_type === 'Book a desk') {
          // load the question from config
          const config = sessionStorage.getItem('config') as any;
          const configObj = JSON.parse(config);
          if (configObj.hasOwnProperty('deskBehalfOptions')) {
            const configQuestion = configObj.deskBehalfOptions.question;
            if (this.dataStore.member.q.hasOwnProperty(configQuestion)) {
              if (this.dataStore.member.q[configQuestion].answer === 'Yes') {
                message_type = 'deskInvite';
              }
            }
          }
        }
      }
    }

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${company.id}`
      };
      const body = {
        "client": client,
        "company": company,
        "parent": parent,
        "service": serviceid,
        "action": action,
        "booking": booking,
        "attendee": attendee,
        "message_type": message_type
      }

      return await this.http.post(`${environment.apiServer}/company/${company.id}/messages`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async pollForCardScans(companyId: any) {

    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/messages?queueType=cardScan`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getUserByCardUID(companyId: any, uid: string) {

    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/cards/user/${uid}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getUserByCardEmail(email: string) {

    const authToken = this.dataStore.authToken;
    const companyid = this.dataStore.company;

    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      return await this.http.get(`${environment.apiServer}/company/${companyid}/cards/user/email/${email}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getMemberDetails(companyId: any, uid: string) {

    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/client/${uid}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }
  async generateSSOToken(companyId: any, first_name: any, last_name: any, email: any) {
    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      const bodyData = {
        first_name: `${first_name}`,
        last_name: `${last_name}`,
        email: `${email}`
      };

      return await this.http.post(`${environment.apiServer}/company/${companyId}/sso`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async ssoLogin(companyId: any, token: any) {
    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      const bodyData = {
        token: `${token}`
      };

      return await this.http.post(`${environment.apiServer}/company/${companyId}/sso/login`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async removeMessageFromQueue(companyId: any, messageHandle: any, queueType: string | null) {
    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      let url = `${environment.apiServer}/company/${companyId}/messages/${btoa(messageHandle)}` as string;

      if (queueType && queueType.length > 0) {
        switch (queueType) {
          case 'cardScan':
            url = `${url}?queueType=cardScan`;
            break;
        }
      }

      return await this.http.delete(url, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }
  async unavailableTimes() {
    const memberid = this.dataStore.member.id;
    const companyid = this.dataStore.company;
    const childCompany = this.dataStore.childCompany;
    const serviceId = this.dataStore.bookingDetails.serviceId;
    const resourceId = this.dataStore.bookingDetails.resourceId;
    const slot = this.dataStore.bookingDetails.time;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'x-company-id': `${companyid}`
      };

      return await this.http.get(`${environment.apiServer}/company/${childCompany}/service/${serviceId}/resource/${resourceId}/unavailable-times/${slot}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async loadBooking(feature: any) {
    const resource = feature.resource;
    const authToken = this.dataStore.authToken;
    const companyid = this.dataStore.childCompany;
    const service = this.dataStore.selectedService;

    try {
      const headers = {
        'authtoken': authToken,
        'x-company-id': `${companyid}`,
        'no-loader': `true`
      };

      return await this.http.get(`${environment.apiServer}/company/${service.company_id}/service/${service.id}/resource/${resource.resource_id}/bookings/${resource.date}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getMeetingAttendees(company_id: number, id: number) {

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${company_id}`,
        'no-loader': `true`
      };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/booking/${id}/attendees`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async addCardUser(userData: any, company_id: number) {
    try {
      const headers = {
        'Content-Type': 'application/json',
      };
      return await this.http.post(`${environment.apiServer}/company/${company_id}/cards/user`, userData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async createClient(clientDetails: any) {
    const companyid = JSON.parse(this.dataStore.config).company;
    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyid}`
      };
      const body = {
        "email": clientDetails.email_address,
        "first_name": clientDetails.first_name,
        "last_name": clientDetails.last_name,
        "mobile": clientDetails.contact_number,
        "consent": true,
        "send_welcome_email": false
      }

      return await this.http.post(`${environment.apiServer}/company/${companyid}/client`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  //////  public basket api
  async createPublicBasket() {

    const authToken = this.dataStore.authToken;
    const companyid = JSON.parse(this.dataStore.config).company;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "company_id": companyid,
      }

      return await this.http.post(`${environment.apiServer}/basket-public`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getPublicBaskets() {
    const authToken = this.dataStore.authToken;
    const memberid = this.dataStore.member.id;
    const companyid = JSON.parse(this.dataStore.config).company;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-member-id': `${memberid}`,
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };

      return await this.http.get(`${environment.apiServer}/baskets-public`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async deletePublicBaskets() {
    const authToken = this.dataStore.authToken;
    const companyid = JSON.parse(this.dataStore.config).company;
    const memberid = this.dataStore.client.id;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${companyid}`,
        'x-member-id': `${memberid}`,
      };

      return await this.http.delete(`${environment.apiServer}/basket-public`, { headers }).toPromise();
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async deletePublicDayBasket(service: any) {
    const authToken = this.dataStore.authToken;
    const companyid = JSON.parse(this.dataStore.config).company;
    const memberid = this.dataStore.client.id;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${companyid}`,
        'x-member-id': `${memberid}`,
        'nounspinn': 'true'
      };

      return await this.http.delete(`${environment.apiServer}/company/${companyid}/service/${service}/day-based/basket-public`, { headers }).toPromise();
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async deleteSpecificPublicDayBasket(service: any, basket: any) {
    const authToken = this.dataStore.authToken;
    const companyid = JSON.parse(this.dataStore.config).company;
    const memberid = this.dataStore.client.id;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${companyid}`,
        'x-member-id': `${memberid}`,
        'nounspinn': 'true'
      };

      return await this.http.delete(`${environment.apiServer}/company/${companyid}/service/${service}/day-based/basket-public/${basket}`, { headers }).toPromise();
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async addPublicServiceItem(basket_id: any, serviceid: any, questions: any, start: any, duration: any) {
    //POST /company/{company}/service/{service}/service_item-public
    const authToken = this.dataStore.authToken;
    const companyid = JSON.parse(this.dataStore.config).company;
    try {
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${companyid}`,
        'nounspinn': 'true'
      };
      const body = {
        "company_id": companyid,
        "service_id": serviceid,
        "questions": questions,
        "start": start.start,
        "duration": parseInt(duration),
      }

      if (questions === null) {
        delete body.questions
      }

      return await this.http.post(`${environment.apiServer}/baskets/${basket_id}/service_item-public`, body, { headers }).toPromise();
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async updatePublicServiceItem(basket_id: any, serviceid: any, questions: any, start: any, duration: any, res: any) {
    //POST /company/{company}/service/{service}/service_item-public
    const authToken = this.dataStore.authToken;
    const companyid = JSON.parse(this.dataStore.config).company;
    try {
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "company_id": companyid,
        "service_id": serviceid,
        "questions": questions,
        "start": start.start,
        "duration": parseInt(duration),
      }

      if (questions === null) {
        delete body.questions
      }

      return await this.http.put(`${environment.apiServer}/baskets/${basket_id}/service_item-public/${res.id}`, body, { headers }).toPromise();
    } catch (error) {
      console.log(error)
      return (error as Error).message;
    }
  }

  async addPublicServiceItemDay(questions: any, selectedDate: any, serviceid: any) {
    const authToken = this.dataStore.authToken;
    const companyid = JSON.parse(this.dataStore.config).company;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'authtoken': authToken,
        'x-company-id': `${companyid}`
      };
      const body = {
        "date": selectedDate,
        "questions": questions
      }

      if (questions === null) {
        delete body.questions
      }

      return await this.http.post(`${environment.apiServer}/company/${companyid}/service/${serviceid}/service_item-public`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getPurchase(companyId: number, serviceId: number, purchaseId: number) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${companyId}/service/${serviceId}/purchase/${purchaseId}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async payPurchase(companyId: number, serviceId: number, purchaseId: number, purchaseData: any) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.put(`${environment.apiServer}/company/${companyId}/service/${serviceId}/purchase/${purchaseId}/pay`, purchaseData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async fetchBookingsForStatus(companyId: number, status: string) {
    try {
      const search = {
        "from": 0,
        "size": 100,
        "query": {
          "bool": {
            "must": [
              {
                "match": {
                  "company_id": companyId
                },
              },
              {
                "match": {
                  "current_status": status
                },
              },
              {
                "match": {
                  "s_status": "Booking"
                }
              }
            ],
            "must_not": [
              {
                "match": {
                  "is_cancelled": true
                }
              }
            ]
          }
        },
        "sort": {
          "just_date": "desc"
        }
      }
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.post(`${environment.apiServer}/company/${companyId}/search/bookings`, search, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async fetchBookingsNoStatus(companyId: number) {
    try {
      const search = {
        "from": 0,
        "size": 100,
        "query": {
          "bool": {
            "must": [
              {
                "match": {
                  "company_id": 37169
                }
              },

              {
                "match": {
                  "s_status": "Booking"
                }
              }
            ],
            "must_not": [
              {
                "match": {
                  "is_cancelled": true
                }
              },
              {
                "regexp": {
                  "current_status": ".*"
                }
              }
            ]
          }
        },
        "sort": {
          "just_date": "desc"
        }
      }
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.post(`${environment.apiServer}/company/${companyId}/search/bookings`, search, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async fetchBookingsForCompanies(companyId: number, companyIds: any[]) {
    try {
      const companies = []
      for (let id of companyIds) {
        companies.push({
          "match": {
            "company_id": id
          }
        })
      }

      const search = {
        "from": 0,
        "size": 100,
        "query": {
          "bool": {
            "must": [

              {
                "match": {
                  "s_status": "Booking"
                }
              }
            ],
            "must_not": [
              {
                "match": {
                  "is_cancelled": true
                }
              }
            ],
            "should": companies
          }
        },
        "sort": {
          "just_date": "desc"
        }
      }
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.post(`${environment.apiServer}/company/${companyId}/search/bookings`, search, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async searchBooking(companyId: number, ref: string) {
    try {
      const time = moment().format("YYYY-MM-DD")
      const search = {
        "from": 0,
        "size": 100,
        "query": {
          "bool": {
            "must": [
              {
                "match": {
                  "company_id": companyId
                },
              },
              {
                "match": {
                  "id": ref
                },
              },
              {
                "match": {
                  "s_status": "Booking"
                }
              }
            ],
            "must_not": [
              {
                "match": {
                  "is_cancelled": true
                }
              }
            ]
          }
        },
        "sort": {
          "just_date": "desc"
        }
      }
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.post(`${environment.apiServer}/company/${companyId}/search/bookings`, search, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async searchBookingByBooker(companyId: number, member: string) {
    try {
      const time = moment().format("YYYY-MM-DD")
      const search = {
        "from": 0,
        "size": 100,
        "query": {
          "bool": {
            "must": [
              {
                "match": {
                  "company_id": companyId
                },
              },
              {
                "match": {
                  "member_id": member
                },
              },
              {
                "match": {
                  "just_date": time
                },
              },
              {
                "match": {
                  "s_status": "Booking"
                }
              }
            ],
            "must_not": [
              {
                "match": {
                  "is_cancelled": true
                }
              }
            ]
          }
        },
        "sort": {
          "just_date": "desc"
        }
      }
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.post(`${environment.apiServer}/company/${companyId}/search/bookings`, search, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async searchClient(companyId: number, answers: any, id: any = undefined) {
    try {
      this.config = JSON.parse(this.dataStore.config);
      const must: any = [];
      must.push({
        "match": {
          "company_id": companyId
        },
      })
      if (answers !== undefined) {
        if (this.config.infoQuestions.lastName) {
          must.push({
            "match": {
              "last_name": answers['lastName']?.value
            }
          },)
        }
        if (this.config.infoQuestions.postcode) {
          must.push({
            "match": {
              "postcode": answers['postcode']?.value
            }
          },)
        }
        // if (this.config.infoQuestions.dob) {
        //   must.push({
        //     "query_string": {
        //       "questions.id": this.config.dobQuestion
        //     }
        //   })
        //   must.push(
        //     {
        //       "query_string": {
        //         // "questions.answer": `${answers['dateOfBirth_year']?.value}-${answers['dateOfBirth_day']?.value}-${answers['dateOfBirth_month']?.value}T00:00:00.000Z`
        //         "questions.answer": `01-01`
        //       }
        //     },
        //   )
        // }
      }
      if (id !== undefined) {
        must.push({
          "match": {
            "id": id
          }
        },)
      }
      const search = {
        "from": 0,
        "size": 100,
        "query": {
          "bool": {
            "must": must
          }
        }
      }
      const headers: any = { 'Content-Type': 'application/json' };
      if (localStorage.getItem('auth_token')) {
        const authToken: string = localStorage.getItem('auth_token')!;
        // headers['authtoken'] = authToken;
        headers['auth-token'] = authToken;
      }
      headers['App-Id'] = environment.jrniAppId;
      headers['App-Key'] = environment.jrniAppKey;
      // return await this.http.post(`${environment.apiServer}/company/${companyId}/search/clients`, search, { headers }).toPromise();
      return await this.http.post(`${environment.jrni}/api/v5/admin/search/client`, search, { headers }).toPromise();
    } catch (error) {

      return (error as Error).message;
    }
  }

  async fetchBookingClients(companyId: number, userIds: any[]) {
    try {
      this.config = JSON.parse(this.dataStore.config);
      const must: any = [];

      const should: any = [];
      for (const id of userIds) {
        const obj = {
          match: {
            id: id
          }
        }
        should.push(obj);
      }

      const search = {
        "from": 0,
        "size": 9000,
        "query": {
          "bool": {
            "should": should
          }
        }
      }
      console.log(search);
      const headers: any = { 'Content-Type': 'application/json' };
      if (localStorage.getItem('auth_token')) {
        const authToken: string = localStorage.getItem('auth_token')!;
        // headers['authtoken'] = authToken;
        headers['auth-token'] = authToken;
      }
      headers['App-Id'] = environment.jrniAppId;
      headers['App-Key'] = environment.jrniAppKey;
      // return await this.http.post(`${environment.apiServer}/company/${companyId}/search/clients`, search, { headers }).toPromise();
      return await this.http.post(`${environment.jrni}/api/v5/admin/search/client`, search, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  //bookings/{{bookingid}}/checkin/{{attendeeid}}
  async checkIn(companyid: number, bookingid: any, attendeeid: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyid}`
      };
      return await this.http.put(`${environment.apiServer}/bookings/${bookingid}/checkin-custom/${attendeeid}`, {}, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  updateStatus(companyId: number, bookingId: number, status: string) {
    console.log(companyId, bookingId, status)
    try {
      const authToken: string = localStorage.getItem('auth_token')!;
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${companyId}`,
        'authToken': `${authToken}`,
        'no-loader': 'true'
      };
      const data: any = {
        settings: { "current_multi_stat": status },
        // attended: true
      }
      status === "" ? data.settings["multi_stats"] = {} : ""
      status !== "" ? data["current_multi_status"] = status : ""

      return this.http.put(`${environment.apiServer}/company/${companyId}/booking/${bookingId}`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async addNoBooking(companyid: number, locationName: string, reg: string, diyWaste: boolean, isStaging: boolean) {
    try {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": "r1OK0DiEqb8CrrGI6Mjm56qXe9oblUx27sA5olIY",
      }
      const body = {
        "company": companyid.toString(),
        "siteName": locationName,
        "vehicleReg": reg,
        "diy_waste": diyWaste,
        "staging": isStaging
      }
      return await this.http.post(`https://ffs4ovo9dg.execute-api.eu-west-1.amazonaws.com/prod/noBookings`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getNoBookings(companyid: number, date: any, isStaging: boolean) {
    try {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": "r1OK0DiEqb8CrrGI6Mjm56qXe9oblUx27sA5olIY",
      }

      return await this.http.get(`https://ffs4ovo9dg.execute-api.eu-west-1.amazonaws.com/prod/noBookings?company=${companyid}&date=${date}&staging=${isStaging}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }
  async getWasteLimit(company_id: number, matchString: string, date: string, time: string) {
    try {

      const headers = {
        'Content-Type': 'application/json'
      };

      return await this.http.get(`${environment.apiServer}/waste?company=${company_id}&matchString=${matchString}&date=${date}&time=${time}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getObserved(config: any) {
    const headers = { 'Content-Type': 'application/json', "X-BL-TOKEN": `${'d4955880c0b6dc1c411ae5f6b58bee7d296f27add686c1798808d3e44e75af6c'}`, 'nounspinn': 'true' };
    const body = {
      "host": `${config.host}`
    }
    return await this.http.post(`${environment.blJrniApi}/anpr/observe`, body, { headers }).toPromise();
  }

  async directJrniUpload(config: any, fileInfo: any, purchase_id: string, booking_id: string) {
    const headers = { };
    const body = fileInfo
    return await this.http.post(`${config.host}/api/v1/purchases/${purchase_id}/bookings/${booking_id}/attach`, body, { headers }).toPromise();
  }

  async jrniReadFiles(company_id: string, purchase_id: string, booking_id: string) {
    const headers = {
      // 'Content-Type':'multipart/form-data; boundary=----WebKitFormBoundarycVkth7JcisTygmeI',
      'upload': 'true',
      "app-id":
        "f6b16c23",
      "app-key":
        "f0bc4f65f4fbfe7b4b3b7264b655f5eb"
    };
    return await this.http.get(`${environment.apiServer}/company/${company_id}/purchases/${purchase_id}/bookings/${booking_id}/attach`, { headers }).toPromise();
  }

  async jrniDeleteFile(company_id: string, purchase_id: string, booking_id: string, file_id: string) {
    const headers = {
      // 'Content-Type':'multipart/form-data; boundary=----WebKitFormBoundarycVkth7JcisTygmeI',
      'upload': 'true',
      "app-id":
        "f6b16c23",
      "app-key":
        "f0bc4f65f4fbfe7b4b3b7264b655f5eb"
    };
    return await this.http.delete(`${environment.apiServer}/company/${company_id}/purchases/${purchase_id}/bookings/${booking_id}/attach/${file_id}`, { headers }).toPromise();
  }

  async getFormSchema(formId: string) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      const data = {
        company: JSON.parse(this.dataStore.config).company,
        client: `${environment.companyName}`,
        form_name: `${formId}`
      };
      return await this.http.post(`${environment.apiServer}/form/schema`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getMetadataForBooking(companyId: number, bookingId: number, metadataType: string) {
    try {
      const headers = { 'Content-Type': 'application/json' };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/booking/${bookingId}/meta/${metadataType}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async addMetadataToBooking(companyId: number, bookingId: number, metadataType: string, data: any) {
    try {
      const headers = { 'Content-Type': 'application/json' };

      return await this.http.post(`${environment.apiServer}/company/${companyId}/booking/${bookingId}/meta/${metadataType}`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

}